/* eslint-disable @angular-eslint/prefer-inject */
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AbstractDataService, LoggerService } from '@pf/shared-services';
import {
    ShipmentFromPackingListsViewModel,
    ShipmentsService,
} from '@control-tower/platform-wms';
import {
    EntityChangeTrackingDto,
    IChangesSearchParams,
    IPagedResult,
    PFWmsEntities,
} from '@pf/shared-common';
import { ShipmentStore } from './shipment.store';
import {
    ShipmentCreate,
    ShipmentRead,
    ShipmentSearchParams,
} from '../../entities/shipment.dto';
import { Operation } from 'fast-json-patch';

@Injectable()
export class ShipmentDataService extends AbstractDataService<
    ShipmentRead,
    ShipmentCreate
> {
    protected EntityName = PFWmsEntities.Shipment;
    constructor(
        private service: ShipmentsService,
        store: ShipmentStore,
        logger: LoggerService
    ) {
        super(store, logger);
    }
    protected createObs$(body: ShipmentCreate): Observable<ShipmentRead> {
        return this.service.shipmentCreate({
            shipmentViewModelCreateBody: body,
        }) as Observable<ShipmentRead>;
    }
    protected deleteObs$(id: string): Observable<ShipmentRead> {
        return this.service.shipmentDelete({
            id,
        }) as Observable<ShipmentRead>;
    }
    protected undoDeleteObs$(id: string): Observable<ShipmentRead> {
        return this.service.shipmentUndoDelete({
            id,
        }) as Observable<ShipmentRead>;
    }
    protected getObs$(id: string): Observable<ShipmentRead> {
        return this.service.shipmentReadById({
            id,
        }) as Observable<ShipmentRead>;
    }
    protected updateObs$(
        id: string,
        operations: Operation[]
    ): Observable<ShipmentRead> {
        return this.service.shipmentUpdatePatch({
            id,
            operation: operations,
        }) as Observable<ShipmentRead>;
    }
    protected searchObs$(
        searchParams: ShipmentSearchParams
    ): Observable<IPagedResult<ShipmentRead>> {
        return this.service.shipmentSearch(searchParams) as Observable<
            IPagedResult<ShipmentRead>
        >;
    }

    protected searchChangesObs$(
        searchParams: IChangesSearchParams
    ): Observable<IPagedResult<EntityChangeTrackingDto<ShipmentRead>>> {
        return this.service.shipmentGetChanges(searchParams) as Observable<
            IPagedResult<EntityChangeTrackingDto<ShipmentRead>>
        >;
    }

    createFromPackingLists(request: ShipmentFromPackingListsViewModel) {
        return this.service
            .shipmentCreateShipmentFromPackList({
                shipmentFromPackingListsViewModel: request,
            })
            .pipe(
                map(result => {
                    const shipment = result.shipment as ShipmentRead;
                    this.store.add(shipment, false);
                    return shipment;
                })
            );
    }

    ship$(shipmentId: string) {
        return this.service
            .shipmentShip({
                id: shipmentId,
            })
            .pipe(
                map(result => {
                    const shipment = result.shipment as ShipmentRead;
                    this.store.add(shipment, false);
                    return shipment;
                })
            );
    }
}
